/***
 * An Autocomplete component that selects an MLS
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import StoreAutoComplete from './StoreAutoComplete'

@observer
export default class MlsAutocomplete extends Component {
  static propTypes = {
    /**
     * An Mls store (Provision)
     */
    mlsStore: PropTypes.object.isRequired, // ideally objectOf(Provision) but doesn't work w/our babel setup presently
  }

  render() {
    const { props } = this

    return <StoreAutoComplete
      placeholder="Select an MLS"
      getValue={props.mlsStore.autocompleteLabelGenerator}
      {...props}
      store={props.mlsStore}
      />
  }
}



// WEBPACK FOOTER //
// client/components/util/auto_complete/MlsAutocomplete.js